"use client";

import { create } from "zustand";
import type { ProposalItem } from "modules/trade-proposals/model/tradeProposal";

export interface ProposalPreviewPayload {
  cards: ProposalItem[];
  chatId: string;
  currentUserId: string;
  isUserGiving: boolean;
  partnerUsername: string;
  partnerUserId: string;
  anyPrinting?: boolean;
  fromMatch?: boolean;
  matchIds?: string[];
  onSuccess?: () => void;
}

interface ProposalPreviewStore {
  open: boolean;
  payload: ProposalPreviewPayload | null;
  openDialog: (payload: ProposalPreviewPayload) => void;
  closeDialog: () => void;
}

export const useProposalPreviewStore = create<ProposalPreviewStore>((set) => ({
  open: false,
  payload: null,
  openDialog: (payload) => set({ open: true, payload }),
  closeDialog: () => set({ open: false }),
}));

export const useProposalPreviewModal = () => ({
  open: useProposalPreviewStore((s) => s.open),
  payload: useProposalPreviewStore((s) => s.payload),
  openDialog: useProposalPreviewStore((s) => s.openDialog),
  closeDialog: useProposalPreviewStore((s) => s.closeDialog),
});
